import React from "react";
import { proxied } from "../../lib/assets";

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_escape-design-lab/artifacts/z9j36n9g_IMG_3010.jpeg";
export const VIDEO_LOGO_URL = "https://customer-assets.emergentagent.com/job_c911de1a-3013-4d29-a08e-7e9f9e5221e5/artifacts/0db0v03t_LuxeTiniLogo.mov";
export const HERO_VIDEO_URL = "https://customer-assets.emergentagent.com/job_escape-design-lab/artifacts/lfm9vpkq_0_Woman_White_1920x1080.mov";

export function Wordmark({ className = "" }) {
  return (
    <span className={`font-serif italic tracking-tight ${className}`}>
      luxe<span className="not-italic font-normal">T</span>ini <span className="text-gold">escapes</span>
    </span>
  );
}

export function BrandMark({ size = 44, className = "", invert = false }) {
  return (
    <img
      src={proxied(LOGO_URL)}
      alt="LuxeTini Escapes"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      style={{ width: size, height: size }}
      data-testid="brand-mark"
    />
  );
}
